export default () => ({
  handleSelectItem(event) {
    if (this.$el.dataset.value === event.target.dataset.value) {
      this.$el.setAttribute('aria-selected', true);
    } else {
      this.$el.removeAttribute('aria-selected');
    }
  },
});
